import React, { useEffect } from 'react';
import LocationPage from '../LocationPage';

const DallasPage: React.FC = () => {
  useEffect(() => {
    document.title = 'AI & Cloud Solutions in Dallas | FretDev';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Enterprise-grade AI and cloud engineering services in Dallas, TX. Trusted by businesses for GenAI solutions, cloud architecture, and ML development.');
    }

    // Add location-specific schema
    const existingScript = document.querySelector('script[data-schema="dallas-location"]');
    if (existingScript) {
      existingScript.remove();
    }

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'FretDev Dallas',
      description: 'AI and cloud engineering services in Dallas',
      areaServed: {
        '@type': 'City',
        name: 'Dallas',
        state: 'Texas',
      },
      url: 'https://fretdev.com/locations/dallas',
      sameAs: 'https://fretdev.com',
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-schema', 'dallas-location');
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.querySelector('script[data-schema="dallas-location"]');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  const serviceAreas = [
    'Dallas',
    'Plano',
    'Arlington',
    'Irving',
    'Fort Worth',
    'Frisco',
    'McKinney',
    'Richardson',
    'Carrollton',
    'Farmer\'s Branch',
  ];

  const highlights = [
    'Local Expertise: Years of experience serving Dallas-area businesses across industries',
    'Quick Response: Based in the DFW area for faster support and consultations',
    'Proven Results: Delivered AI solutions that drive measurable ROI for local companies',
    'Enterprise Standards: Production-grade infrastructure and security for DFW businesses',
    'Ongoing Support: Dedicated support team available for Dallas-area clients',
  ];

  return (
    <LocationPage
      city="Dallas"
      region="Dallas-Fort Worth"
      description="FretDev is your Dallas-based AI and cloud engineering partner. We serve businesses throughout the Dallas area with enterprise-grade solutions in generative AI, cloud architecture, and machine learning — delivered with the responsiveness of a local team and the expertise of seasoned enterprise engineers."
      serviceAreas={serviceAreas}
      highlights={highlights}
    />
  );
};

export default DallasPage;
